import { render, staticRenderFns } from "./orderStatus.vue?vue&type=template&id=5e979265&scoped=true"
import script from "./orderStatus.vue?vue&type=script&lang=js"
export * from "./orderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e979265",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e979265')) {
      api.createRecord('5e979265', component.options)
    } else {
      api.reload('5e979265', component.options)
    }
    module.hot.accept("./orderStatus.vue?vue&type=template&id=5e979265&scoped=true", function () {
      api.rerender('5e979265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/orderDetailChild/orderStatus.vue"
export default component.exports